import React, { Component } from "react"
import ServicesHeroSection from "./services-hero-section"
import ServicesSection from "./services-section"
import Testimonials from "../Testimonials/index"
import OurClients from "../Home/our-clients-section"

import "./services.css"

class OurServices extends Component {
  render() {
    return (
      <React.Fragment>
        <ServicesHeroSection />
        <ServicesSection />
        <Testimonials />
        <OurClients />
      </React.Fragment>
    )
  }
}

export default OurServices
